module.exports = __webpack_public_path__ + "static/media/md-checkmark-circle.a49f05e9.svg";